<template>
  <div class="xntg-page">
    <div class="xntg-actions">
      <Button type="primary" @click="openCreate">新增</Button>
      <Button type="primary" :loading="listLoading" @click="loadMachines">刷新</Button>
    </div>

    <Table :columns="columns" :data="machines" :loading="listLoading" border />

    <Modal
      v-model="modalVisible"
      :title="editing ? '编辑虚拟糖果机' : '新增虚拟糖果机'"
      width="720"
      @on-cancel="closeModal"
    >
      <Form ref="machineForm" :model="form" :rules="rules" :label-width="100">
        <FormItem label="名称" prop="roomname">
          <Input v-model="form.roomname" placeholder="请输入名称" />
        </FormItem>
        <FormItem label="等级" prop="roomlv">
          <InputNumber v-model="form.roomlv" :min="0" :precision="0" style="width: 100%" />
        </FormItem>
        <FormItem label="单价" prop="price">
          <InputNumber v-model="form.price" :min="1" :precision="0" style="width: 100%" />
        </FormItem>
        <FormItem label="备注名" prop="broomname">
          <Input v-model="form.broomname" placeholder="请输入备注名" />
        </FormItem>
        <FormItem label="排序" prop="sort">
          <InputNumber v-model="form.sort" :min="0" :precision="0" style="width: 100%" />
        </FormItem>
        <FormItem label="封面图" prop="image">
          <img v-if="form.image" :src="imageUrl(form.image)" class="form-image" />
          <single-upload :key="uploadKey + '-cover'" title="上传封面图" @update:image="setImage" />
        </FormItem>
        <FormItem label="规则图（选填）">
          <img v-if="form.rule" :src="imageUrl(form.rule)" class="form-image" />
          <single-upload :key="uploadKey + '-rule'" title="上传规则图" @update:image="setRule" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="closeModal">取消</Button>
        <Button type="primary" :loading="saving" @click="submit">确定</Button>
      </div>
    </Modal>

    <Modal v-model="recordVisible" title="游戏记录" width="1024" @on-cancel="closeRecords">
      <DatePicker
        v-model="recordDateRange"
        type="daterange"
        placeholder="选择游戏时间"
        style="width: 220px; margin-right: 10px"
      />
      <Button type="primary" :loading="recordLoading" @click="searchRecords">查询</Button>
      <Table
        class="record-table"
        :columns="recordColumns"
        :data="records"
        :loading="recordLoading"
        height="330"
        border
      />
      <Page
        class="record-pages"
        :total="recordTotal"
        :current="recordPage"
        :page-size="50"
        @on-change="changeRecordPage"
      />
      <div slot="footer">
        <Button @click="closeRecords">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import SingleUpload from '@/components/Upload/singleUpload';
import {
  selmgcmachine,
  cerXNTGMachine,
  updateXNTGMachine,
  updateMachineStatus,
  cmsDevilcityGamelist,
} from '@/api/machine';

function emptyForm() {
  return {
    roomid: null,
    roomname: '',
    roomlv: null,
    price: null,
    broomname: '',
    sort: 0,
    image: '',
    rule: '',
  };
}

export default {
  components: { SingleUpload },
  data() {
    return {
      machines: [],
      listLoading: false,
      modalVisible: false,
      saving: false,
      editing: false,
      statusChangingRoomId: null,
      recordVisible: false,
      recordRoomId: null,
      recordDateRange: [],
      recordLoading: false,
      recordRequestId: 0,
      recordPage: 1,
      recordTotal: 0,
      records: [],
      uploadKey: 0,
      form: emptyForm(),
      rules: {
        roomname: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        roomlv: [{ required: true, type: 'number', message: '请输入等级', trigger: 'change' }],
        price: [{ required: true, type: 'number', message: '请输入单价', trigger: 'change' }],
        sort: [{ required: true, type: 'number', message: '请输入排序', trigger: 'change' }],
        image: [{ required: true, message: '请上传封面图', trigger: 'change' }],
      },
      recordColumns: [
        { title: '上机时间', key: 'uptime', minWidth: 155 },
        { title: '下机时间', key: 'downtime', minWidth: 155 },
        { title: '用户 ID', key: 'user_id', width: 100 },
        { title: '上机前金币', key: 'upmoney', width: 115 },
        { title: '投币数', key: 'coinnumber', width: 100 },
        { title: '中奖币数', key: 'wincoin', width: 105 },
      ],
      columns: [
        { title: '房间 ID', key: 'roomid', width: 100 },
        { title: '名称', key: 'roomname', minWidth: 140 },
        { title: '等级', key: 'roomlv', width: 80 },
        { title: '单价', key: 'price', width: 90 },
        { title: '备注名', key: 'broomname', minWidth: 140 },
        { title: '排序', key: 'sort', width: 80 },
        {
          title: '封面图', width: 90,
          render: (h, { row }) => this.imageCell(h, row.roomimg),
        },
        {
          title: '机器状态', width: 100,
          render: (h, { row }) => {
            const status = Number(row.status);
            return h('span', status === 1 ? '开机' : status === 2 ? '维护' : '关机');
          },
        },
        {
          title: '操作', width: 245, align: 'center',
          render: (h, { row }) => {
            const status = Number(row.status);
            const busy = this.statusChangingRoomId !== null;
            const button = (label, onClick, color) => h('Button', {
              props: { type: color || 'primary', size: 'small', disabled: busy },
              style: { marginRight: '5px' },
              on: { click: onClick },
            }, label);
            return h('div', [
              button('编辑', () => this.openEdit(row)),
              button('游戏记录', () => this.openRecords(row)),
              status === 1
                ? button('关机', () => this.changeStatus(row, 0), 'error')
                : button('开机', () => this.changeStatus(row, 1), 'success'),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.loadMachines();
  },
  methods: {
    imageUrl(path) {
      if (!path) return '';
      return /^https?:\/\//.test(path) ? path : `${process.env.OSS || ''}${path}`;
    },
    imageCell(h, path) {
      return path ? h('img', {
        attrs: { src: this.imageUrl(path) },
        style: { width: '50px', height: '50px', objectFit: 'contain' },
      }) : h('span', '-');
    },
    async loadMachines() {
      this.listLoading = true;
      try {
        const res = await selmgcmachine({ machinetype: 70 });
        this.machines = Array.isArray(res.data) ? res.data : [];
      } catch (error) {
        this.machines = [];
      } finally {
        this.listLoading = false;
      }
    },
    openCreate() {
      this.editing = false;
      this.form = emptyForm();
      this.uploadKey += 1;
      this.modalVisible = true;
    },
    openEdit(row) {
      this.editing = true;
      this.form = {
        roomid: row.roomid,
        roomname: row.roomname || '',
        roomlv: Number(row.roomlv),
        price: Number(row.price),
        broomname: row.broomname || '',
        sort: Number(row.sort) || 0,
        image: row.roomimg || '',
        rule: row.rule || '',
      };
      this.uploadKey += 1;
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
      this.$refs.machineForm && this.$refs.machineForm.resetFields();
    },
    setImage(path) {
      this.form.image = path;
      this.$refs.machineForm.validateField('image');
    },
    setRule(path) {
      this.form.rule = path;
    },
    async changeStatus(row, status) {
      if (this.statusChangingRoomId !== null) return;
      this.statusChangingRoomId = row.roomid;
      try {
        await updateMachineStatus({ roomid: row.roomid, status });
        this.$Message.success(status === 1 ? '开机成功' : '关机成功');
        await this.loadMachines();
      } catch (error) {
        this.$Message.error(status === 1 ? '开机失败' : '关机失败');
      } finally {
        this.statusChangingRoomId = null;
      }
    },
    openRecords(row) {
      this.recordRoomId = row.roomid;
      this.recordDateRange = [];
      this.recordPage = 1;
      this.recordTotal = 0;
      this.records = [];
      this.recordVisible = true;
      this.loadRecords();
    },
    closeRecords() {
      this.recordVisible = false;
      this.recordRoomId = null;
      this.recordRequestId += 1;
      this.recordLoading = false;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    searchRecords() {
      this.recordPage = 1;
      this.loadRecords();
    },
    changeRecordPage(page) {
      this.recordPage = page;
      this.loadRecords();
    },
    async loadRecords() {
      if (this.recordRoomId === null) return;
      const roomid = this.recordRoomId;
      const range = this.recordDateRange;
      const requestId = ++this.recordRequestId;
      this.recordLoading = true;
      try {
        const res = await cmsDevilcityGamelist({
          roomid,
          page: this.recordPage,
          starttime: range.length === 2 && range[0] ? this.formatDate(range[0]) : '',
          endtime: range.length === 2 && range[1] ? this.formatDate(range[1]) : '',
        });
        if (this.recordRoomId !== roomid || this.recordRequestId !== requestId) return;
        const data = res.data || {};
        this.records = Array.isArray(data.rows) ? data.rows : [];
        this.recordTotal = Number(data.pagination && data.pagination.total) || 0;
      } catch (error) {
        if (this.recordRoomId === roomid && this.recordRequestId === requestId) {
          this.records = [];
          this.recordTotal = 0;
          this.$Message.error('游戏记录加载失败');
        }
      } finally {
        if (this.recordRoomId === roomid && this.recordRequestId === requestId) this.recordLoading = false;
      }
    },
    submit() {
      this.$refs.machineForm.validate(valid => {
        if (valid) this.saveMachine();
      });
    },
    async saveMachine() {
      if (this.saving) return;
      this.saving = true;
      const payload = {
        roomname: this.form.roomname.trim(),
        roomlv: this.form.roomlv,
        price: this.form.price,
        broomname: this.form.broomname.trim(),
        sort: this.form.sort,
        image: this.form.image,
        rule: this.form.rule,
      };
      try {
        if (this.editing) {
          await updateXNTGMachine({ roomid: this.form.roomid, ...payload });
        } else {
          await cerXNTGMachine(payload);
        }
        this.$Message.success(this.editing ? '更新成功' : '新增成功');
        this.closeModal();
        await this.loadMachines();
      } catch (error) {
        this.$Message.error(this.editing ? '更新失败' : '新增失败');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.xntg-actions { margin-bottom: 12px; }
.xntg-actions .ivu-btn + .ivu-btn { margin-left: 10px; }
.form-image { display: block; max-width: 180px; max-height: 120px; margin-bottom: 8px; object-fit: contain; }
.record-table { margin-top: 12px; }
.record-pages { margin-top: 12px; text-align: right; }
</style>
